"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableHeaderData = void 0;
const helpers_1 = require("Views/Partials/Components/TableCore/helpers");
const components_1 = require("../components");
const shouldHaveTypeColumn = (rows) => {
    const rowsWithType = rows.filter(row => row.type && row.type.length !== 0);
    return rowsWithType.length > 0;
};
const shouldHaveDurationColumn = (rows) => {
    const rowsWithDuration = rows.filter(row => row.duration && row.duration.length !== 0);
    return rowsWithDuration.length > 0;
};
const getTableHeaderData = (rows, dictionary) => {
    return components_1.learningComponentHeaderConfig
        .map(headerCell => {
        if (rows && rows.length !== 0) {
            if (headerCell.name === components_1.LearningComponentHeaderCellEnum.Type && !shouldHaveTypeColumn(rows))
                return;
            if (headerCell.name === components_1.LearningComponentHeaderCellEnum.Duration &&
                !shouldHaveDurationColumn(rows))
                return;
        }
        return Object.assign(Object.assign({}, headerCell), { label: (0, helpers_1.getValueFromDictionary)(dictionary, headerCell.label) });
    })
        .filter(column => column);
};
exports.getTableHeaderData = getTableHeaderData;
